import type { Form } from 'factorial-form'
import isNull from 'lodash/isNull'

import {
  FieldTypes,
  MaxOptionLabelLength,
} from 'modules/custom_resources/store/collections/customFields/fields'

// We can't rely on form.isComplete to know if the CFs form is complete, since
// we have some values that can be empty and that's ok for certain types of CF.
// That's why we use this custom check to ignore the values that are not
// required in order to submit the form

export default function (form: Form) {
  const ignoredValues = ['editable', 'visible', 'options']
  const { field_type: fieldType } = form.data()

  if (fieldType !== FieldTypes.rating) {
    ignoredValues.push('min_value', 'max_value')
  }

  if (fieldType !== FieldTypes.singleChoice && fieldType !== FieldTypes.multipleChoice) {
    ignoredValues.push('choice_options')
  }

  return !Object.keys(form.fields)
    .filter((fieldKey) => !ignoredValues.includes(fieldKey))
    .some((fieldKey) => {
      const field = form.fields[fieldKey]

      if (['choice_options'].includes(fieldKey)) {
        // We need at least one option with a value and not passing max length
        if (field?.value.length === 0) {
          return true
        }

        return field?.value.some(
          (option: any) => option.label === '' || option.label.length > MaxOptionLabelLength
        )
      }

      switch (field?.type) {
        case 'number':
        case 'cents':
        case 'boolean':
          return field.value === '' || isNull(field.value)

        case 'string':
        case 'any':
          return !field.value

        default:
          throw new Error(`Unsupported form field type ${field?.type} in CFs form`)
      }
    })
}
